<app-loadable-content [loadingController]="orderLoadingController" (onRetry)="loadOrder()">
    <app-title>{{ 'order' | translate }} {{ order.id }}</app-title>
    <div align="center">
        <app-toolbar [subject]="order" [actions]="orderToolbarModel.actions" [compactActions]="orderToolbarModel.compactActions"></app-toolbar>
    </div>
    <p></p>
    <div align="center"><a href="{{'https://dashboard.stripe.com/payments/' + order.status.payment.id}}" target="_blank" *ngIf="order.status && order.status.payment">{{ 'stripe_payment' | translate }}</a></div>
</app-loadable-content>
